<template>
  <div class="header">
    <div class="begin-time">预计开课时间：{{ time }}</div>
    <div class="csm-services" @click="$emit('contact')">
      联系客服
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
          fill="none"
          fill-rule="evenodd"
          stroke="#FFF"
          stroke-linecap="round"
          stroke-width="3"
          d="M10 3.515l7.778 7.778a1 1 0 0 1 0 1.414L10 20.485"
        />
      </svg>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Header extends Vue {
  @Prop(String) time!: string;
}
</script>

<style lang="scss" scoped>
// $header-bar-color: linear-gradient(264deg, #fdc538, #fd9246);
$header-bar-color: #ee612a;
$font-color: #fff;
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 89px;
  padding: 0 20px 0 33px;
  color: $font-color;
  font-weight: 500;
  font-size: 26px;
  font-style: normal;
  letter-spacing: 0.49px;
  background: $header-bar-color;
  .csm-services {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 182px;
    height: 57px;
    padding-left: 12px;
    font-weight: 500;
    border: solid 1px $font-color;
    border-radius: 8px;
    svg {
      width: 24px;
      height: 24px;
    }
  }
}
// #h5-dark-blue {
//   .header {
//     background: #ffbe00;
//     color: #333;
//     .csm-services {
//       border: solid 1px #333333;
//       &::after {
//         background-image: url('../assets/arrow-left-black.svg');
//       }
//     }
//   }
// }
</style>
